import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SubscriptionStatus } from '@clubhub/ignite/models';
import { AuthorizeService } from '@shared/services/authorize.service';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';
import { firstValueFrom } from 'rxjs';

export interface SubscriptionStatusGuardOptions {
  redirect?: string;
  allowUnauthorized?: boolean;
}

export function subscriptionStatusGuard(
  isValidStatus: (status: SubscriptionStatus) => boolean,
  { redirect, allowUnauthorized = false }: SubscriptionStatusGuardOptions = {},
): CanActivateFn {
  return async () => {
    const authService = inject(AuthorizeService);
    const clubhubDataService = inject(ClubHubDataService);
    const router = inject(Router);

    if (authService.isLoggedIn) {
      const subscriptionStatus = await firstValueFrom(clubhubDataService.get<SubscriptionStatus>('IgniteSubscriptionStatus'));

      if (isValidStatus(subscriptionStatus)) {
        return true;
      }
    } else if (!authService.isLoggedIn && allowUnauthorized) {
      return true;
    }

    if (redirect) {
      return router.parseUrl(`/${redirect.replace(/^\/+/, '')}`);
    }

    return false;
  };
}

export const isAccountOwnerOrAccessManager = (status: SubscriptionStatus) => status.accountOwner || status.accessManager;

export const isBroker = (status: SubscriptionStatus) => status.broker;

export const hasActiveSubscription = (status: SubscriptionStatus) => status.active;
